import { DepositRequest } from '../../pages/Deposites/Deposit';
import apiBaseUrl from '../ApiBaseUrl';


const handleResponse = async (response: Response) => {
    if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};

export const fetchAllDepositMethods = async () => {
    var token = localStorage.getItem('authToken')?.toString();
    try {
        console.log('Fetching data from API...');
        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/GetAllDepositMethods`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        console.log('API response received:', response);
  
        if (!response.ok) {
            console.error('Response not OK:', response.statusText);
        } else {
            const data = await handleResponse(response);
            console.log('Data fetched successfully:', data);
            return data;
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

// Get auth token
const getAuthToken = () => {
    return localStorage.getItem('authToken')?.toString();
};



// Fetch deposit request by ID
export const fetchDepositRequestbyid = async (depositId: number) => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/GetDepositRequestById?depositId=${depositId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to fetch deposit request: ${response.statusText} - ${errorText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching deposit request by ID:', error);
        throw error;
    }
};

// Update deposit status
export const updateDepositStatus = async (depositId: number, statusId: number, remarks?: string) => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/UpdateDepositStatus`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                depositId,
                statusId,
                remarks,
                updatedBy: localStorage.getItem('userId') || 'admin',
                updatedAt: new Date().toISOString()
            }),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to update deposit status: ${response.statusText} - ${errorText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating deposit status:', error);
        throw error;
    }
};

// Approve deposit request
export const approveDepositRequest = async (depositId: number, remarks?: string) => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/ApproveDepositRequest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                depositId,
                remarks,
                approvedBy: localStorage.getItem('userId') || 'admin',
                approvedAt: new Date().toISOString()
            }),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to approve deposit request: ${response.statusText} - ${errorText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error approving deposit request:', error);
        throw error;
    }
};

// Reject deposit request
export const rejectDepositRequest = async (depositId: number, remarks: string) => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/RejectDepositRequest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                depositId,
                remarks,
                rejectedBy: localStorage.getItem('userId') || 'admin',
                rejectedAt: new Date().toISOString()
            }),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to reject deposit request: ${response.statusText} - ${errorText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error rejecting deposit request:', error);
        throw error;
    }
};

// Mark deposit as Win/Lose
export const markDepositResult = async (depositId: number, result: 'Win' | 'Lose', remarks?: string) => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/MarkDepositResult`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                depositId,
                result,
                remarks,
                markedBy: localStorage.getItem('userId') || 'admin',
                markedAt: new Date().toISOString()
            }),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to mark deposit result: ${response.statusText} - ${errorText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error marking deposit result:', error);
        throw error;
    }
};

// Get deposit statistics
export const getDepositStatistics = async () => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/GetDepositStatistics`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to fetch deposit statistics: ${response.statusText} - ${errorText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching deposit statistics:', error);
        throw error;
    }
};

// Export deposit data
export const exportDepositData = async (filters?: any, format: 'csv' | 'excel' = 'csv') => {
    try {
        const token = getAuthToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const queryParams = new URLSearchParams();
        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    queryParams.append(key, value.toString());
                }
            });
        }
        queryParams.append('format', format);

        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/ExportDepositData?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to export deposit data: ${response.statusText} - ${errorText}`);
        }

        // Handle file download
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `deposits_${new Date().toISOString().split('T')[0]}.${format}`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        return { success: true };
    } catch (error) {
        console.error('Error exporting deposit data:', error);
        throw error;
    }
};


export const fetchAllDigitalCoinsById = async (depositMethodId: number) => {
    var token = localStorage.getItem('authToken')?.toString();
    console.log('DepositMethodId', depositMethodId);
    try {
        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/GetAllDigitalCoins?depositMethodId=${depositMethodId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            console.error('Response not OK:', response.statusText);
        } else {
            const data = await handleResponse(response);
            console.log('Data fetched successfully:', data);
            return data;
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

export const DepositReceipt = async (formData: FormData) => {
    var token = localStorage.getItem('authToken')?.toString();
    console.log('Sending deposit data to API...');
    try {
        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Deposit/CreateDeposit`, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${token}`,
                // Uncomment the following line if your API requires specific headers
                // 'Content-Type': 'multipart/form-data',
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('Response not OK:', response.statusText, errorText);
            throw new Error(`Error fetching data: ${response.statusText}`);
        }
        else {
            const data = await handleResponse(response);
            console.log('Data fetched successfully:', data);
            return data;
        }

    } catch (error) {
        console.error('Error creating deposit:', error);
        throw error;
    }
};

// src/Common/SharedApis/DespositMethods.tsx
export const bindPocketAddress = async (data: { digitalCoinId: string, address: string, userId: string, lastModify: string }) => {
    var token = localStorage.getItem('authToken')?.toString();
    console.log('Sending deposit data to API...');
    try {
        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/WalletAddress/AddOrUpdateWalletAddress`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });

        const responseText = await response.text(); // Read response as text

        if (!response.ok) {
            console.error('Response not OK:', response.statusText, responseText);
            throw new Error(`Error fetching data: ${response.statusText}`);
        } else {
            console.log('Response text:', responseText);
            // Process response as needed (e.g., display message or handle text response)
            return responseText;
        }
    } catch (error) {
        console.error('Error creating deposit:', error);
        throw error;
    }
};

export const currencyWithDraw = async (data: { requestUserId: string, withDrawAmount: number, withDrawToAddress: string, statusId: number, isActive: boolean }) => {
    var token = localStorage.getItem('authToken')?.toString();
    console.log('Sending withdrawal data to API...');
    try {
        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/WithDraw/CreateWithdrawRequest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });

        const responseText = await response.text(); // Read response as text

        if (!response.ok) {
            console.error('Response not OK:', response.statusText, responseText);
            throw new Error(`Error fetching data: ${response.statusText}`);
        } else {
            console.log('Response text:', responseText);
            return responseText;
        }
    } catch (error) {
        console.error('Error creating withdrawal:', error);
        throw error;
    }
};

export const walletadressbyuserid = async (userId: number) => {
    var token = localStorage.getItem('authToken')?.toString();
    const apiUrl = `${apiBaseUrl.apiBaseUrl}/WalletAddress/GetAllByUserId/${userId}`;
    console.log('Fetching from:', apiUrl);
    try {
        const response = await fetch(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            const errorText = await response.text(); // Capture error details
            console.error('Response not OK:', response.statusText);
            console.error('Error details:', errorText);
            return null;
        }
        const data = await response.json();
        console.log('Data fetched successfully:', data);
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        return null;
    }
};

export const getbalance = async (userId: string) => {
    var token = localStorage.getItem('authToken')?.toString();
    try {
        const response = await fetch(`${apiBaseUrl.apiBaseUrl}/Balance/GetBalanceByUserId?userId=${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            console.error('Response not OK:', response.statusText);
            return null;
        }
        const data = await response.json();
        console.log('Data fetched successfully:', data);
        return data.avaliableBalance; // Return only the availableBalance
    } catch (error) {
        console.error('Error fetching data:', error);
        return null;
    }
};

